import { FC } from 'react'
import 'src/sass/InfoBlock.scss'

type InfoBlockProps = {
  label: string
  value: string
}

const InfoBlock: FC<InfoBlockProps> = ({ label, value }) => {
  return (
    <div className="info-block">
      <label className="info-label">{label}</label>
      <p className="info-value">{value}</p>
    </div>
  )
}

export default InfoBlock